import { useHistory } from 'react-router';
import { NewConversationPayload } from '../types/Messaging/NewConversationPayload';

type ConversationRouterState = NewConversationPayload &
  Required<Pick<NewConversationPayload, 'meta_data'>>;
export default function useChatNavigator() {
  const history = useHistory();
  /**
   *
   * @param payload only add counterparts as participants, current user will be added automatically
   * @returns automatically adds payload as chat route state, just incase conversation does not already exist, payload will be used to create a new conversation
   *
   */
  const goToConversation = (payload?: ConversationRouterState) =>
    history.push('/dashboard/chat', payload);

  return { goToConversation };
}
